var exports = {
  "$d": "x28a7bf27--0ce83e--link-area",
  "Bo": "x28a7bf27--0ce83e--banner-container",
  "vW": "x28a7bf27--0ce83e--inner",
  "nV": "x28a7bf27--0ce83e--left-desktop-image",
  "ys": "x28a7bf27--0ce83e--right-desktop-image",
  "Yu": "x28a7bf27--0ce83e--text-block",
  "VA": "x28a7bf27--0ce83e--mortgage-logo",
  "Qq": "x28a7bf27--0ce83e--text",
  "vK": "x28a7bf27--0ce83e--banner",
  "mm": "x28a7bf27--0ce83e--mobile-banner",
  "x6": "x28a7bf27--0ce83e--button",
};

module.exports = exports;
